"use client";
import dynamic from 'next/dynamic';

import React, { useEffect } from "react";
const LogoLoading = dynamic(() => import('@/components/ui/LogoLoading'));
import logWithTimestamp from "@/utils/refactored/helpers";

const Loading = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-[#141414]">
      <LogoLoading />
    </div>
  );
};

export default Loading;
